module.exports = __webpack_public_path__ + "img/filterGrey.1dbe67ff.svg";